import { render, staticRenderFns } from "./responsavelId.vue?vue&type=template&id=1da5049a&scoped=true"
import script from "./responsavelId.vue?vue&type=script&lang=js"
export * from "./responsavelId.vue?vue&type=script&lang=js"
import style0 from "./responsavelId.vue?vue&type=style&index=0&id=1da5049a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5049a",
  null
  
)

export default component.exports